/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { observer } from "mobx-react";
import * as React from "react";

import { IUserPersonaProps } from "./IUserPersonaProps";
import { setUserNameInTextProp } from "./UserPersona.mappers";
import { UserPersonaWithPicture } from "./UserPersonaWithPicture";
import { UserPersonaWithoutPicture } from "./UserPersonaWithoutPicture";

/**
 * A HOC which injects the caching of user profile picture and user display name.
 */
export const UserPersona = observer(function UserPersona(props: IUserPersonaProps): JSX.Element {
    const { hidePicture } = props;
    const propsWithUsername = setUserNameInTextProp(props);

    return hidePicture ? <UserPersonaWithoutPicture {...propsWithUsername} /> : <UserPersonaWithPicture {...propsWithUsername} />;
});
